var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgShareNewProfileSmall = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    viewBox: "0 0 13 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#1F1F1F",
    strokeWidth: 0.125,
    d: "m8.178 9.808.043.028.036-.037A2.43 2.43 0 0 1 10 9.063a2.437 2.437 0 1 1-2.272 1.556l.019-.048-.043-.027-2.881-1.852-.043-.028-.036.037a2.438 2.438 0 1 1 0-3.402l.036.037.043-.028 2.881-1.852.043-.027-.019-.048a2.434 2.434 0 1 1 .529.82l-.036-.037-.043.028-2.881 1.852-.043.027.019.048c.22.567.22 1.195 0 1.762l-.019.048.043.027z"
  })));
};
const Memo = /*#__PURE__*/memo(SvgShareNewProfileSmall);
export default Memo;